export const culture = {
    locale: "en-GB",
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    dateFormat: 'dd/mm/yy',
    datePlaceholder: 'dd/mm/yyyy',
    weekHeader: 'Wk',
    firstDay: 1,
    monthDayFormat: 'dd/mm',
    shortFormat: "d M",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'HH:mm:ss',
    shortTimeFormat: 'HH:mm',
    decimalSeparator: ".",
    currencyDecimalSeparator: '.',
    currencyGroupSeparator: ',',
    moneyWithCurrencyFormat: "{c}{v}",
    from: 'From',
    by: 'By',
    fromFormat: 'From {0}',
    byFormat: 'By {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Done',
    prevText: 'Prev',
    nextText: 'Next',
    currentText: 'Today',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
